import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { SmoothLink, GoogleMapUrl } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../../styles';
import DetailHeaderWrapper from '../../components/DetailHeaderWrapper';
import ContactModal from '../../components/ContactModal';

const styles = css`
  .DetailHeader {
    margin: 0 0 56px 0;
    @media (min-width: 992px) {
      margin: 0;
    }
  }
  .DetailHeader_photoButton {
    position: absolute;
    right: 0;
    top: 30px;
    width: 54px;
    height: 80px;
    background-color: rgba(173,137,47,.9);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
    color:#FFFFFF;
    a {
      color: #FFFFFF;
      &:hover {
        opacity: .8;
      }
    }
    @media (min-width: 992px) {
      top: 40%;
    }
  }
  .DetailHeader_mapButton {
    position: absolute;
    right: 0;
    top: 110px;
    width: 54px;
    height: 80px;
    background-color: rgba(49,49,49,.9);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
    color:#FFFFFF;
    a {
      color: #FFFFFF;
      &:hover {
        opacity: .8;
      }
    }
    @media (min-width: 992px) {
      top: calc(40% + 80px);
    }
  }
  .DetailHeader_downloadButton {
    position: absolute;
    right: 0;
    top: 190px;
    width: 54px;
    height: 80px;
    background-color: rgba(36,36,36,.9);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 800;
    font-size: 18px;
    color:#FFFFFF;
    a {
      color: #FFFFFF;
      &:hover {
        opacity: .8;
      }
    }
    @media (min-width: 992px) {
      top: calc(40% + 160px);
    }
  }
  .DetailHeader_infoWrapper {
    position: relative;
    background-color: rgba(63,63,63,.8);
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      position: absolute;
      bottom: 56px;
      left: 0;
      background-color: rgba(63,63,63,.8);
      width: 1120px;
      max-width: 100%;
      display: flex;
      flex-direction: row;
    }
    .DetailHeader_heading {
      padding: 20px 20px 30px 20px;
      width: 100%;
      flex-shrink: 0;
      h1 {
        font-family: ${typography.Serif};
        font-weight: 300;
        font-size: 29px;
        color: #FFFFFF;
        letter-spacing: 2px;
        text-align: left;
        line-height: 29px;
        position: relative;
        margin: 0 0 20px 0;
        span {
          font-family: ${typography.SanSerif};
          font-weight: 700;
          font-size: 15px;
          color: ${colors.color3Dark};
          letter-spacing: 0;
          text-transform: uppercase;
        }
        &:after {
          content: '';
          background: ${colors.color2};
          width: 100px;
          height: 3px;
          position: absolute;
          display: block;
          bottom: -10px;
        }
      }
      @media (min-width: 992px) {
        padding: 50px 60px;
        width: 60%;
        flex-shrink: 0;
        h1 {
          font-weight: 300;
          font-size: 40px;
          color: #FFFFFF;
          letter-spacing: 4px;
          text-align: left;
          line-height: 1;
          position: relative;
          margin: 0 0 60px 0;
          span {
            font-weight: 700;
            font-size: 18px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-transform: uppercase;
          }
          &:after {
            content: '';
            background: ${colors.color2};
            width: 100px;
            height: 3px;
            position: absolute;
            display: block;
            bottom: -30px;
          }
        }
      }
      ul {
        list-style: none;
        text-align: left;
        padding: 0;
        li {
          display: inline-block;
          font-size: 17px;
          line-height: 17px;
          color: #FFFFFF;
          margin: 0 10px 0 0;
          padding: 0 10px 0 0;
          border-right: 1px solid #FFFFFF;
          a {
            color: #E0CF9B;
            font-weight: 900;
          }
          &:last-child {
            border: none;
          }
        }
      }
    }
    .DetailHeader_info {
      flex-grow: 1;
      background-color: rgba(63,63,63,.6);
      list-style: none;
      color: #FFFFFF;
      padding: 0;
      margin: 0;
      text-align: left;
      @media (min-width: 992px) {
        border-left: ${colors.color5Dark} solid 3px;
      }
      li {
        padding: 15px 20px;
        text-align: left;
        border-bottom: ${colors.color5Dark} solid 1px;
        font-size: 22px;
        line-height: 1;
        display: inline-block;
        width: 100%;
        vertical-align: top;
        font-weight: 300;
        a {
          color: #E0CF9B;
          font-weight: 900;
        }
      }
      .DetailHeader_price {
        font-weight: 300;
        font-size: 32px;
        padding: 25px 20px;
      }
      .DetailHeader_status {
        background-color: #313131;
        font-weight: 900;
        text-transform: uppercase;
        font-size: 14px;
      }
      .DetailHeader_iconListItem {
        display: inline-block;
        text-align: center;
        width: 33%;
        border: 0;
        .DetailHeader_iconListIcon {
          display: block;
          height: 30px;
          line-height: 30px;
          margin: 15px 0;
          img {
            height: 30px;
            width: auto;
          }
        }
        .DetailHeader_iconListValue {
          font-size: 22px;
          font-weight: 900;
          display: block;
          margin: 0 0 5px 0;
        }
      }
    }
  }
  .DetailHeader_menuWrapper {
    position: absolute;
    width: 100%;
    bottom: -56px;
    left: 0;
    height: 56px;
    @media (min-width: 992px) {
      bottom: 0;
    }
    .DetailHeader_menu {
      background-color: rgba(183,150,65,.8);
      line-height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      list-style: none;
      padding: 0;
      height: 56px;
      li {
        display: none;
        font-weight: 900;
        flex-grow: 1;
        text-transform: uppercase;
        @media (min-width: 992px) {
          display: inline-block;
          flex-grow: 0;
        }
        a {
          color: #FFFFFF;
          line-height: 56px;
          padding: 0 15px;
        }
      }
      .ContactModal_button {
        background-color: ${colors.color2};
        color: #FFFFFF;
        line-height: 56px;
        padding: 0 15px;
        display: block;
        text-align: center;
        width: 100%;
        cursor: pointer;
        @media (min-width: 992px) {
          background-color: ${colors.color1};
          width: auto;
        }
      }
    }
  }
`;

function HomeDetailHeader({ community, home, plan }) {
  return (
    <div className={styles}>
      <DetailHeaderWrapper imageUrl={get(home, 'photos[0].contentUrl')}>
        <div className="DetailHeader">
          <div className="DetailHeader_infoWrapper">
            <div className="DetailHeader_heading">
              <h1>
                {get(home, 'address.streetAddress')}<br />
                <span>{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}</span>
              </h1>
              <ul>
                {
                  get(community, 'name') &&
                  <li>Community: <Link name="community-detail" community={community}>{get(community, 'name')}</Link></li>
                }
                {
                  get(plan, 'name') &&
                  <li>Floor Plan: <Link name="plan-detail" plan={plan}>{get(plan, 'name')}</Link></li>
                }
              </ul>
              {
                get(home, 'isModel') === true &&
                <ul>
                  <li>
                    <span>Model Home </span>
                    {
                      get(home, 'isModelHours') &&
                      <span>
                        <span>Hours: </span>
                        {get(home, 'isModelHours')}
                      </span>
                    }
                  </li>
                </ul>
              }
            </div>
            <ul className="DetailHeader_info">
              {
                get(home, 'price') > 10000 &&
                <li className="DetailHeader_price">{numeral(get(home, 'price')).format('$0,0')}</li>
              }
              {
                get(home, 'status') &&
                <li className="DetailHeader_status">Status: {get(home, 'status')}</li>
              }
              {
                get(home, 'beds') &&
                <li className="DetailHeader_iconListItem">
                  <span className="DetailHeader_iconListIcon"><img src="/images/icon-beds.svg" alt="" /></span>
                  <span className="DetailHeader_iconListValue">{get(home, 'beds')}</span>
                  Beds
                </li>
              }
              {
                get(home, 'bathsFull') &&
                <li className="DetailHeader_iconListItem">
                  <span className="DetailHeader_iconListIcon"><img src="/images/icon-baths.svg" alt="" /></span>
                  <span className="DetailHeader_iconListValue">
                    <span>{get(home, 'bathsFull') + (get(home, 'bathsHalf', 0) * 0.5)}</span>
                  </span>
                  Baths
                </li>
              }
              {
                get(home, 'sqft') &&
                <li className="DetailHeader_iconListItem">
                  <span className="DetailHeader_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                  <span className="DetailHeader_iconListValue">{numeral(get(home, 'sqft')).format('0,0')}</span>
                  SQ FT
                </li>
              }
            </ul>
          </div>
          <div className="DetailHeader_menuWrapper">
            <ul className="DetailHeader_menu">
              <li className="d-inline-block">
                <ContactModal
                  formLabel="Home Showing Request"
                  formName="homeShowingRequest"
                >Request Showing</ContactModal>
              </li>
              <li><SmoothLink href="#description">Home Description</SmoothLink></li>
              {
                get(home, 'tourUrl') &&
                <li><SmoothLink href="#tour">Virtual Tour</SmoothLink></li>
              }
              {
                get(home, 'floorplanPhotos', []).length > 0 &&
                <li><SmoothLink href="#plans">Floor Plans</SmoothLink></li>
              }
              <li><SmoothLink href="#gallery">Photo Gallery</SmoothLink></li>
            </ul>
          </div>
          {
            get(home, 'photos', []).length > 0 &&
            <div className="DetailHeader_photoButton">
              <LightBox
                items={get(home, 'photos', [])}
                button={(
                  <div>
                    <img src="/images/icon-photos-white.svg" alt="" />
                    <div>{get(home, 'photos', []).length}</div>
                  </div>
                )}
              />
            </div>
          }
          <div className="DetailHeader_mapButton">
            <div>
              <a href={GoogleMapUrl(home)} target="_blank" rel="noopener noreferrer">
                <img src="/images/icon-map-pin-white.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </DetailHeaderWrapper>
    </div>
  );
}

HomeDetailHeader.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
};

HomeDetailHeader.defaultProps = {
  plan: undefined,
  community: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
  },
  {
    required: {
      home: true,
    },
  },
)(HomeDetailHeader);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDetailHeader.js